<template>
  <label :class="labelClass" :for="forValue">
    <span><slot /></span>
    <span v-if="!isRequired" class="text-muted text-sm font-normal">
      (Optional)</span
    >
  </label>
</template>

<script setup lang="ts">
const { isRequired } = defineProps({
  isRequired: {
    type: Boolean,
    default: false,
  },
  forValue: {
    type: String,
    default: "",
  },
});

const labelClass = computed(() => ({
  "text-sm font-semibold text-surface-700 mb-2": true,
  // "after:content-['*'] after:ml-0.5 after:text-red-500": isRequired,
}));
</script>
